export { default as DashboardPageTemplate } from "./DashboardPageTemplate";
export { default as PageTemplate } from "./PageTemplate";
